var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root"}},[_c('h5',[_vm._v(_vm._s(_vm.meditation.title))]),_c('p',{staticClass:"text-muted",domProps:{"innerHTML":_vm._s(_vm.meditation.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }